import { type User } from "../../../store/slices/userSlice"
import { store } from "../../../store/store"
import { USER_ID_KEY } from "../../../urls"
import { getNameUser } from "./getNameUser"
import { getUnitAddress } from "./getUnitAddres"

export const getDataUser = (userID : number | string , unitID : number | string): {nameUser : string, nameAddress: string} => {
    const lsUserID = window.localStorage.getItem(USER_ID_KEY)
    const currentUnit = store.getState().units.units.filter((u) => u.id === unitID)[0]
    const nameAddress = getUnitAddress(currentUnit) ?? ""
    let nameUser = "User"
    
    if( Number(lsUserID)  ===  Number(userID)){
        nameUser = getNameUser(store.getState().user.currentUser as User)
    } else {
        const user = store.getState()?.user?.allUsers?.filter((u :any) => u.id === userID)[0]
        nameUser = getNameUser(user)
    }
    return {nameUser, nameAddress}
            

}

